module.exports = __webpack_public_path__ + "4b3e7ae23a1fe880d957c9fd6c7594c2.pdf";